// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Erectile dysfunction REFILL 09.17.26" (638e0246-f461-435c-975b-2a9465ab21d9). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiErectileDysfunctionRefillQuestions = [
  {
    field: 'mdiErectileDysfunctionRefill_medicationWerePrescribedHelped',
    label: 'Has the medication you were prescribed helped?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes_im_very_happy', value: "Yes, I'm very happy" },
        { key: 'yes_it_works_somewhat', value: 'Yes, it works somewhat' },
        { key: 'not_really', value: 'Not really' },
        { key: 'not_at_all', value: 'Not at all.' }
      ]
    },
    extras: { mdiQuestionId: '6f02a765-8beb-47f8-8da9-96ad0d6e385e' }
  },
  {
    field: 'mdiErectileDysfunctionRefill_anythingChangedMedicalHistory',
    label: 'Has anything changed in your medical history?',
    type: 'select',
    educationalSlide: '• Surgeries?  Medications? Allergies? New diagnosis?',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'no_everything_is_the_same',
          value: 'No, everything is the same'
        },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'a8b3df71-9a63-43ee-9b41-d843ede23e37' }
  },
  {
    field: 'mdiErectileDysfunctionRefill_listNewChangesMedicalHistory',
    label: 'Please list any new changes to your medical history below:',
    type: 'info',
    subLabel:
      '• On the next slide you can upload pictures/files if helpful\n• Please include any information about medications/allergies/surgeries/diagnosis.',
    answer: {
      type: 'text',
      name: 'mdiErectileDysfunctionRefill_listNewChangesMedicalHistory',
      rows: 4
    },
    extras: { mdiQuestionId: '4267e24d-0bdc-456c-ac52-8fb27add3870' }
  },
  {
    field: 'mdiErectileDysfunctionRefill_anythingElseYoudLikeTell',
    label: "Anything else you'd like to tell us?",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'nothing_else', value: 'Nothing else' }
      ]
    },
    extras: { mdiQuestionId: 'f7905f2f-1fe9-4efc-8f82-085767e19dfe' }
  },
  {
    field: 'mdiErectileDysfunctionRefill_likeDiscuss',
    label: 'What would you like to discuss?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'shipping_question', value: 'Shipping question' },
        { key: 'billing_question', value: 'Billing question' },
        { key: 'question_for_support', value: 'Question for support' },
        { key: 'question_for_doctor', value: 'Question for doctor' }
      ]
    },
    extras: { mdiQuestionId: '05f5a117-f287-45f9-b462-81b5da3d4619' }
  },
  {
    field: 'mdiErectileDysfunctionRefill_makeSureContactSupportDirectly',
    label: 'Please make sure to contact support directly via email.',
    type: 'info',
    subLabel: "• Click on the 'support' button on the top right.",
    answer: {},
    extras: {
      mdiQuestionId: 'ff07fb9f-fbba-43e1-b41d-8b0201934c9d',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiErectileDysfunctionRefill_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent  (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiErectileDysfunctionRefill_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: '4b0117f9-6304-4356-bd52-ec55224701d9' }
  },
  {
    field: 'mdiErectileDysfunctionRefill_tellDoctorAnythingYoudLike',
    label: "Tell your doctor anything you'd like.",
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiErectileDysfunctionRefill_tellDoctorAnythingYoudLike',
      rows: 4
    },
    extras: { mdiQuestionId: '1fd3d058-9429-4800-a5a3-ee5f55e213ac' }
  },
  {
    field: 'mdiErectileDysfunctionRefill_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiErectileDysfunctionRefillAnswerField = Partial<
  QuestionAnswerMap<typeof mdiErectileDysfunctionRefillQuestions>
>;

export default mdiErectileDysfunctionRefillQuestions;
